import { Component, OnInit } from '@angular/core';
import { TemplateService } from 'src/app/services/template/template.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-template-branch-map',
  templateUrl: './template-branch-map.component.html',
  styleUrls: ['./template-branch-map.component.css']
})
export class TemplateBranchMapComponent implements OnInit {

  Submitted: boolean = false;
  TemplateBranchMapList:any;
  BranchList:any;
  SessionList:any;

  constructor(private templateservice:TemplateService,private LookupService: LookupService, private globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }
  


    TemplateModel = {
      TemplateID: 0,
      BranchID: 0,
      SessionID: 0,
      TemplateTypeID: 0,
      Template: '',          
  };

  ClearTemplate(){
            this.Submitted = false;
            this.TemplateModel.BranchID = 0;
            this.TemplateModel.SessionID = 0;           
        };

        validation() {

          return this.TemplateModel.BranchID == 0 || this.TemplateModel.SessionID == 0;
      }

      SaveTemplateBranchMap(valid) { 
        this.Submitted = true;
        if (valid ) {
          this.spinnerService.show();
          this.templateservice.SaveTemplateBranchMap(JSON.stringify(this.TemplateModel),JSON.stringify(this.TemplateBranchMapList)).subscribe((data: any) => {
            this.spinnerService.hide();
            if (data.webResponse.Status && this.TemplateModel.TemplateID == 0) {
              this.ClearTemplate();
            }
      
            if (data.webResponse.Status) {
              this.globalHelper.CheckActionStatus(data);
              this.GetAllTemplateBranchMap();
            }
      
            this.Submitted = false;
      
          });
        }
      };

      GetAllTemplateBranchMap() {
        this.templateservice.GetAllTemplateBranchMap(JSON.stringify(this.TemplateModel)).subscribe((data: any) => {
         this.TemplateBranchMapList = data.TemplateBranchMapList;
         });
      
      }

      GetAllSession() {
        this.TemplateModel.SessionID = 0;
        this.TemplateBranchMapList = [];
        var item = {
            'ItemId': this.TemplateModel.BranchID,
        }

        this.LookupService.GetLookupsList('Session', JSON.stringify(item)).subscribe((data: any) => {
            this.SessionList = data.LookupItems;
        });
    }

      
  
  ngOnInit() {
    this.GetAllBranch();

  }

  
  GetAllBranch() {
    this.LookupService.GetLookupsList('BranchAll', '').subscribe((data: any) =>{
        this.BranchList = data.LookupItems;
    });

}
}
